import axios from "@/libs/api.request";
import { getToken } from "@/libs/util";
// 获取列表
export const getList = params => {
  return axios.request({
    url: "/shipments/proof",
    params,
    method: "get"
  });
};